var _defs, _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTenantBg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_38",
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    fill: "#6b7ef2",
    "data-name": "Ellipse 38",
    transform: "translate(0 -.12)"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-3{fill:#fff}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Mask_Group_31",
    clipPath: "url(#prefix__clip-path)",
    "data-name": "Mask Group 31",
    transform: "rotate(90 30.44 30.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2074",
    "data-name": "Group 2074",
    transform: "rotate(90 173.951 61.521)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1521",
    d: "M312.643 168.795v-.618a74.9 74.9 0 0 0-44.129-68.26L112.693 10.029a74.864 74.864 0 0 0-102.258 27.44l-.413.717a74.872 74.872 0 0 0 6.108 83.821A74.56 74.56 0 0 0 .118 168.29v.79a74.557 74.557 0 0 0 16.206 46.476 74.983 74.983 0 0 0-6.114 84.021l.3.527a74.975 74.975 0 0 0 102.428 27.406l158.683-91.692a75.109 75.109 0 0 0 41.016-66.85v-.173z",
    className: "prefix__cls-3",
    "data-name": "Path 1521",
    transform: "translate(27.389 27.379)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_3927",
    width: 150.603,
    height: 312.523,
    fill: "#938aa8",
    "data-name": "Rectangle 3927",
    rx: 61.118,
    transform: "rotate(90 109.673 230.33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_3928",
    width: 150.558,
    height: 337.25,
    fill: "#39bbfc",
    "data-name": "Rectangle 3928",
    rx: 61.174,
    transform: "rotate(60 65.243 299.622)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_3929",
    width: 150.558,
    height: 337.25,
    fill: "#ff4d7f",
    "data-name": "Rectangle 3929",
    rx: 61.085,
    transform: "rotate(119.979 135.012 190.353)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_35",
    cx: 75.279,
    cy: 75.279,
    r: 75.279,
    fill: "#ba6aff",
    "data-name": "Ellipse 35",
    transform: "translate(189.473 120.892)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_36",
    cx: 32.119,
    cy: 32.119,
    r: 32.119,
    className: "prefix__cls-3",
    "data-name": "Ellipse 36",
    transform: "translate(232.633 164.057)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_37",
    cx: 13.048,
    cy: 13.048,
    r: 13.048,
    fill: "#43264f",
    "data-name": "Ellipse 37",
    transform: "translate(251.703 183.126)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantBg3);
export default __webpack_public_path__ + "static/media/tenant_bg3.4cedce5dde40a9fd3e6b48dbab99d7f4.svg";
export { ForwardRef as ReactComponent };